<template>
  <div
    class="align-center background-color-white d-flex flex-column full-width pb-5 pt-7 px-7"
  >
    <div class="font-weight-semibold mb-4 text-center">Sign Up</div>
    <v-form
      ref="form"
      v-model="valid"
      class="full-width"
      @submit.prevent="signUp"
    >
      <EmailInput
        :email="registration.email"
        :update="updateRegistration"
        autofocus
      />
      <PasswordInput
        :label="'Password (Min. 6 Characters)'"
        :password="registration.password"
        :update="updateRegistration"
      />
      <ConfirmPasswordInput
        :confirmPassword="registration.confirmPassword"
        :label="'Confirm Password (Min. 6 Characters)'"
        :password="registration.password"
        :update="updateRegistration"
      />
      <v-btn
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          get started
        </div>
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import ConfirmPasswordInput from "@/components/Inputs/ConfirmPassword.vue";
import EmailInput from "@/components/Inputs/Email.vue";
import PasswordInput from "@/components/Inputs/Password.vue";

export default {
  name: "SignUpRegistrationContent",
  components: {
    ConfirmPasswordInput,
    EmailInput,
    PasswordInput,
  },
  data() {
    return {
      valid: true,
    };
  },
  props: {
    registration: Object,
    signUp: Function,
    updateRegistration: Function,
  },
};
</script>
